<template>

  <div>
    
    <input-drop-media
      @input="uploadFile">
      </input-drop-media>

    <ValidateMessage :error="validateErrors.note" />

  </div>

</template>

<script>
import InputDropMedia from '@/components/Fields/InputDropMedia'

export default {
  name: 'JobAttachForm',
  components: {
    InputDropMedia
  },
  props: [
  ],
  data () {
    return {
      validateErrors: false,
      loading: false
    }
  },
  computed: {
    job () {
      return this.$store.getters.getJob
    }
  },
  created () {
  },
  methods: {
    /*
    uploadFile
    */
    uploadFile (medias) {
      this.loading = true

      Promise.all(medias.map((media) => {
        return this.$store
        .dispatch('createJobAttach', {
          job_id: this.job._id,
          attach_media_id: media
        })
      }))
      .then((attachs) => {
        this.loading = false
        this.$emit('created', attachs)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobAttach/JobAttachForm.vue